


import { Component, Vue, Emit } from 'vue-property-decorator';
import LatestCodeDisplay from '@/components/LatestCodeDisplay/index.vue';
import ExistingCodeInput from '@/components/ExistingCodeInput/index.vue';
import { namespace } from 'vuex-class';
import { HouseConfiguration } from '../../utils/api';
import { Notification, NotificationType } from '../NotificationBanner/NotificationBanner.models';

const configurationModule = namespace('configuration');
const notifyModule = namespace('notify');

@Component({
  components: {
    LatestCodeDisplay,
    ExistingCodeInput
  }
})
export default class ConfigCodeDialog extends Vue {
  @configurationModule.Action private sendEmail!: (email: string) => Promise<void>;
  @configurationModule.Action private setConfigurationByCode!: (code: string) => Promise<HouseConfiguration>;
  @notifyModule.Action private closeNotificationsOfOrigin!: (origin: string) => Promise<void>;
  @notifyModule.Action private showNotification!: (data: Notification) => void;
  @notifyModule.Action private closeNotification!: (key: string) => Promise<void>;

  @Emit()
  private closeModal() {
    return;
  }

  private async submitCode(code: string) {
    const configuration: HouseConfiguration = await this.setConfigurationByCode(code);

    if (configuration) {
      this.closeModal();
    } else {
      this.onCodeError();
    }
  }

  private onCodeError() {
    this.showNotification({
      headline: this.$t('components.directCode.error') as string,
      type: NotificationType.Error,
      key: 'OnlineCode/codeInvalid'
    });
  }

  private closeValidationMessage() {
    this.closeNotification('OnlineCode/codeInvalid');
  }

  private beforeDestroy() {
    this.closeNotificationsOfOrigin('ConfigCodeDialog');
    this.closeNotification('OnlineCode/codeInvalid');
  }
}
